import en from '../en/filters'

const cz: typeof en = {
  filter_author: 'Autor',
  filter_year: 'Rok',
  filter_place: 'Místo',
  filter_object: 'Předmět',
  filter_iiif_format: 'Dostupné v IIIF',
  category: 'Kategorie',
  vise: 'Vise',
  sort: 'Řazení',
  delete_all: 'Odstranit vše',
}

export default cz
